import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-col', [_c('b-form-group', {
    class: {
      'required-field': !_vm.form.nome
    },
    attrs: {
      "id": "nome",
      "label-for": "nome",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('nome'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.nome.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.nome, "$model", $$v);
      },
      expression: "$v.form.nome.$model"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-col', [_c('b-form-group', {
    class: {
      'required-field': !_vm.form.sigla
    },
    attrs: {
      "id": "sigla",
      "label-for": "sigla",
      "label": "Sigla"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('sigla')
    },
    model: {
      value: _vm.$v.form.sigla.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.sigla, "$model", $$v);
      },
      expression: "$v.form.sigla.$model"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "conversor",
      "label-for": "conversor",
      "label": "Conversor"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.conversor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "conversor", $$v);
      },
      expression: "form.conversor"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_conversor",
      "label-for": "tipo_conversor",
      "label": "Tipo da conversão"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.tipo_conversor,
      expression: "form.tipo_conversor"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo_conversor",
      "id": "tipo_conversor"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "tipo_conversor", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.tiposConversor, function (t, index) {
    return _c('option', {
      key: 'tipo' + index,
      domProps: {
        "value": t.id
      }
    }, [_vm._v(" " + _vm._s(t.descricao) + " ")]);
  }), 0)])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "unidade_tributavel",
      "label-for": "unidade_tributavel",
      "label": "Unidade tributável"
    }
  }, [_c('VueSelect', {
    attrs: {
      "id": "unidade_tributavel",
      "label": "sigla",
      "options": _vm.unidadesMedidas,
      "reduce": function reduce(unidade) {
        return unidade.id;
      },
      "clearable": true,
      "placeholder": "Opcional"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.sigla) + " - " + _vm._s(option.nome) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.sigla) + " - " + _vm._s(option.nome) + " ")];
      }
    }]),
    model: {
      value: _vm.form.unidade_tributavel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "unidade_tributavel", $$v);
      },
      expression: "form.unidade_tributavel"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Nenhuma unidade encontrada ")])], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_un",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'unidades'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };